import { SMART_LOCK_API_ENDPOINTS } from '../URLConstants';
import SmartLockApiCallerInstance from '../utils/SmartLockApiCallerInstance';

export const GetAllTicket = async (page, limit, isActive) => {
  let url = `${SMART_LOCK_API_ENDPOINTS.TICKET_MANAGEMENT_URL}?page=${page}&limit=${limit}`;

  if (isActive === 'true' || isActive === 'false') {
    url += `&isActive=${isActive}`;
  }

  const response = await SmartLockApiCallerInstance.get(url);
  return response;
};

export const UpdateTicketStatusData = async (id, data) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.TICKET_MANAGEMENT_URL}/${id}`,
    data
  );
  return response;
};

export const GetDeviceById = async () => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.DEVICE_ID_LIST}`
  );
  return response;
};

export const GetTicketById = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.TICKET_MANAGEMENT_URL}/${id}`
  );
  return response;
};

export const AddTicketData = async (data) => {
  const response = await SmartLockApiCallerInstance.post(
    SMART_LOCK_API_ENDPOINTS.TICKET_MANAGEMENT_URL,
    data
  );
  return response;
};
